// Authentication token management
// Stores JWT token in localStorage for cross-domain authentication

import { clearLeaguesSnapshot } from './leaguesSnapshot'
import { clearCurrentUserSnapshot } from './currentUserSnapshot'

const TOKEN_KEY = 'fantasy_predictor_token';

export const saveToken = (token) => {
    if (token) {
        localStorage.setItem(TOKEN_KEY, token);
    }
};

export const getToken = () => {
    return localStorage.getItem(TOKEN_KEY);
};

export const removeToken = () => {
    localStorage.removeItem(TOKEN_KEY);
    clearLeaguesSnapshot();
    clearCurrentUserSnapshot();
};

export const getAuthHeaders = () => {
    const token = getToken();
    if (token) {
        return {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        };
    }
    return {
        'Content-Type': 'application/json'
    };
};
